module.exports = __webpack_public_path__ + "static/assets/6de06131f1124722ba9dbd735ba1b62f.gif";